import { INavigationCallback } from './types';

function getUserConfirmation(dialogKey: string, callback: INavigationCallback) {
  // @ts-ignore
  const dialogTrigger = window[dialogKey];

  if (dialogTrigger) {
    return dialogTrigger<INavigationCallback>(callback);
  }

  callback(true);
}

export default getUserConfirmation;
